module.exports = __webpack_public_path__ + "img/logo-white.9538e364.png";